<template>
  <div>
    <a-row span="24">
      <a-col span="5">
        <div class="left-content-box">
          <FirstStepComponent ref="leftComponent" v-model="signOptionList"
                              @reset="onResetDragItemEvent"></FirstStepComponent>
        </div>
      </a-col>
      <a-col span="14" style="padding-left: 20px;padding-right: 20px">
        <div class="center-box">
          <div style="padding: 20px 24px 20px;">
            <div style="font-size: 20px;line-height: 28px;height: 28px;font-weight: bold;width: 100%;text-align: left">
              新建合同
            </div>
            <div style="text-align: left;height: 32px;line-height: 32px;padding-top: 20px;padding-bottom: 20px">
              <span style="font-size:14px;"><span style="color:#F5222D;">*</span>
                <span style="color:#F04134;"> </span>
                <span style="font-size:13px;color:rgba(0, 0, 0, 0.847058823529412);">选择模板</span>
              </span>
              <a-select v-model="templateId" placeholder="请选择模版名称"
                        @change="onTemplateChange"
                        style="max-width: 623px;width: calc(100% - 120px);margin-left: 20px">
                <a-select-option v-for="item in templateOptions"
                                 :key="item.pactTemplateId"
                                 :value="item.pactTemplateId"
                >{{ item.pactTemplateName }}
                </a-select-option>
              </a-select>
            </div>
            <div style="margin-top: 20px;width: 700px;position: relative;border: 1px solid #e9e9e9;"
                 ref="customPdfViewer">
              <custom-pdf-viewer :url="pdfUrl" @updateSettlement="updateSettlementEvent"></custom-pdf-viewer>
              <div v-if="showSeal" class="drag-float-box" :style="{'height': miniPdfHeight+'px'}">
                <div class='box-height' v-if='contractTemplateType==1'>
                  <VueDraggableResizable
                    @dragging="(x,y)=>onDraggingContractCodeEvent(x,y)"
                    :parent="true"
                    :w="240"
                    :h="32"
                    :min-width="240"
                    :min-height="32"
                    :max-height="32"
                    :max-width="240"
                    :handles="[]"
                    :x="superviseLocation.codeXCoordinate"
                    :y="superviseLocation.codeYCoordinate"
                    :z="9999990"
                    :resizable="false"
                    :lock-aspect-ratio="true">
                    <div class='contract_code_image'>
                      <img src="../../../../assets/images/contract_code_image.png">
                    </div>
                  </VueDraggableResizable>
                  <VueDraggableResizable
                    @dragging="(x,y)=>onDraggingQrcodeEvent(x,y)"
                    :parent="true"
                    :w="160"
                    :h="160"
                    :min-width="160"
                    :min-height="160"
                    :max-height="160"
                    :max-width="160"
                    :handles="[]"
                    :x="superviseLocation.qrCodeXCoordinate"
                    :y="superviseLocation.qrCodeYCoordinate"
                    :z="9999990"
                    :resizable="false"
                    :lock-aspect-ratio="true">
                    <div class='qrcode_image'>
                      <img src="../../../../assets/images/qrcode_image.png">
                    </div>
                  </VueDraggableResizable>
                </div>
                <VueDraggableResizable
                  v-for="(item,index) in signOptionList"
                  :key="'date'+index"
                  @dragging="(x,y)=>onDraggingDateEvent(x,y,item,index)"
                  :parent="true"
                  :w="206"
                  :h="36"
                  :min-width="206"
                  :min-height="36"
                  :max-height="36"
                  :max-width="206"
                  :handles="[]"
                  :x="item.dateXCoordinate?item.dateXCoordinate:0"
                  :y="item.dateYCoordinate?item.dateYCoordinate:0"
                  :z="1000"
                  :resizable="false"
                  :lock-aspect-ratio="true">
                  <div class="drag-box-2">
                    <img src="../../../../assets/images/icon_sign_date_seal.png">
                    <span style="margin-top: 26px">签章日期{{ index + 1 }}</span>
                  </div>
                </VueDraggableResizable>
                <VueDraggableResizable
                  v-for="(item,index) in signOptionList"
                  :key="'sign'+index"
                  @dragging="(x,y)=>onDraggingEvent(x,y,item,index)"
                  :parent="true"
                  :w="item.signType===1?160:160"
                  :h="item.signType===1?160:66"
                  :min-width="item.signType===1?160:160"
                  :min-height="item.signType===1?160:66"
                  :max-height="item.signType===1?160:160"
                  :max-width="item.signType===1?160:66"
                  :handles="[]"
                  :x="item.signXCoordinate>0?item.signXCoordinate:0"
                  :y="item.signYCoordinate>0?item.signYCoordinate:0"
                  :z="1000"
                  :resizable="false"
                  :lock-aspect-ratio="true">
                  <div :class="item.signType===1?'drag-box':'drag-box-1'">
                    <img v-if="item.signType===1" src="../../../../assets/images/official_seal.png">
                    <img v-else src="../../../../assets/images/private_seal.png">
                    <span style="margin-top: 20px">签章{{ index + 1 }}</span>
                  </div>
                </VueDraggableResizable>
              </div>
            </div>
          </div>
        </div>
      </a-col>
      <a-col span="5">
        <div class="right-content-box">
          <a-form-model
            ref="fillForm"
            :model="fillForm"
            :rules="fillRule"
            :label-col="{span:1}"
            :wrapper-col="{span:23}"
          >
            <div class="title-box">
            <span><span style="color:#FAAD14;">第三步：</span>
              <span style="color:rgba(0, 0, 0, 0.847058823529412);">填写字段</span>
            </span>
              <a-button type="primary" @click="applyEvent" :loading="applyLoading"
                        style="position: absolute;right: 10px;top: 13px;">全部应用
              </a-button>
            </div>
            <a-form-model-item v-if="updateOrderShow()"
                               label="" :colon="false" :required="false"
                               style="margin-left: 16px;margin-bottom: 8px;width: calc(100% - 32px)">
              <a-form-model-item label="" :colon="false" :required="false" style="margin-bottom: 0;width: 100% ">
                <div>
                  <span style="margin-left: 10px">订单来源</span>
                  <a @click="fillOrderInfoEvent" style="margin-left: 10%;">填充信息</a>
                  <a-select v-model="orderType" style="width: 100%">
                    <a-select-option :value="2">平台订单</a-select-option>
                    <a-select-option :value="1">云仓订单</a-select-option>
                  </a-select>
                </div>
                <div>
                  <span style="margin-left: 10px">订单号</span>
                  <a-input
                    v-model="fillForm.orderNumber"
                    placeholder="请输入"
                    style="width: 100%"
                  ></a-input>
                </div>
              </a-form-model-item>
            </a-form-model-item>
            <a-form-model-item
              v-for="(item,index) in fillForm.fillOptionList" :key="item.name"
              label=""
              :colon="false"
              :required="false"
              style="margin-left: 16px;margin-bottom: 8px;width: calc(100% - 32px)"
              :prop="'fillOptionList.'+index+'.value'"
              :rules="fillRule['value']"
            >
              <span>{{ item.name }}
                <template v-if="item.isSpecial">
                  <span
                    style="margin-left: 20px;color: #8F8F8F">{{
                      item.value && item.value.length ? '已填充' : '未填充'
                    }}</span>
                  <a style="float: right" @click="editOptionItemEvent(item,index)">编辑</a>
                </template>
               </span> <br>
              <a-input
                v-if="!item.isSpecial"
                v-model="item.value"
                placeholder="请输入"
                style="width: 100%;"
              ></a-input>
            </a-form-model-item>
          </a-form-model>
        </div>
      </a-col>
    </a-row>
    <a-row span="24" style="background-color: white;margin-top: 20px">
      <a-col span="24" style="box-sizing: border-box;padding: 20px">
        <a-button type="primary" @click="onSaveEvent" :loading="saveLoading" style="float: right;">
          生成合同
        </a-button>
        <a-button @click="cancelEvent" style="float: right;margin-right: 20px">取 消</a-button>
      </a-col>
    </a-row>
    <a-modal
      style="z-index: 10000"
      :title="editOptionItem?editOptionItem.fillEnumKeyMean:''"
      :width="900"
      :visible="!!(editOptionItem && editOptionItem.fillEnumKeyMean==='出游人')"
      @ok="onConfirmEditOptionEvent"
      @cancel="editOptionItem={}">
      <commonTableEditor
        ref="tableEditor"
        :virtual-names="virtualNames"
        :columns="editColumns"
        :column-keys="editColumnsKeys"
        :beforeSave="beforeSaveItem"
        :data-source="editOptionItem&&editOptionItem.value?editOptionItem.value:[]"
      >
        <template slot="cardType" slot-scope="item">
          <a-select
            v-if="item.record.editable"
            v-model="item.record.cardType"
            @change="(value)=> onCardNoChange(item.record,value)"
            placeholder="请选择"
            style="width: 100%">
            <a-select-option
              v-for="item in cardOrderOptions"
              :key="item.key"
              :value="item.key">{{ item.value }}
            </a-select-option>
          </a-select>
          <span v-else>{{ item.record.cardTypeStr }}</span>
        </template>
      </commonTableEditor>
    </a-modal>
    <a-modal
      style="z-index: 10000"
      :title="editOptionItem?editOptionItem.fillEnumKeyMean:''"
      :width="900"
      :visible="!!(editOptionItem && editOptionItem.fillEnumKeyMean==='套餐关联行程')"
      @ok="onConfirmEditOptionEvent"
      @cancel="editOptionItem={}">
      <a-textarea
        v-model="editOptionItem.value"
        :maxLength="100" placeholder="请输入"
        :auto-size="{ minRows: 6, maxRows: 20 }"></a-textarea>
    </a-modal>
  </div>
</template>

<script>
import FirstStepComponent from './components/FirstStepComponent'
import commonTableEditor from './components/commonTableEditor'
import VueDraggableResizable from 'vue-draggable-resizable'
import 'vue-draggable-resizable/dist/VueDraggableResizable.css'
import contractMixin from '@/views/service/serviceProvider/contract/contractMixins'
import ContractTemplateHelper from './ContractTemplateHelper'
import CustomPdfViewer from '../../../../customComponents/CustomPdfViewer'

String.prototype.replaceAll = function(oldStr, newStr) { //将oldStr替换成newStr
  const reg = new RegExp(oldStr, 'g') //创建正则RegExp对象
  return this.replace(reg, newStr)
}
export default {
  name: 'ContractCreator',
  components: { FirstStepComponent, commonTableEditor, VueDraggableResizable, CustomPdfViewer },
  mixins: [contractMixin],
  data() {
    return {
      showSeal: false,//显示签章
      applyLoading: false,
      showOrderModal: false,
      orderType: 2,//1是云仓订单，2是平台订单
      fillForm: {
        orderNumber: undefined,//订单号
        fillOptionList: []//订单填充项
      },
      fillRule: {
        value: [{ validator: this.validatorFillContent, trigger: ['blur', 'change'] }]
      },
      templateId: undefined,
      templateName: '',
      templateText: '',
      templateDetail: {},//模版详情信息
      templateOptions: [],
      signOptionList: [],
      editOptionItem: {},//编辑项
      virtualNames: [],
      editColumns: [],
      editColumnsKeys: [],
      pdfUrl: '',//这个是显示的pdf地址
      contractPafUrl: '',//合同的pdf地址
      miniPdfHeight: 1000,
      cardOrderOptions: [
        {
          value: '身份证号',
          key: 1
        },
        {
          value: '护照',
          key: 2
        },
        {
          value: '港澳通行证',
          key: 3
        },
        {
          value: '台湾通行证',
          key: 4
        },
        {
          value: '军官证',
          key: 5
        },
        {
          value: '台胞证',
          key: 6
        },
        {
          value: '回乡证',
          key: 7
        },
        {
          value: '户口簿',
          key: 8
        },
        {
          value: '出生证明',
          key: 9
        }
      ]
    }
  },
  mounted() {
    this.getTemplateList()
  },
  watch: {
    $route: function(to, form) {
      if (to.name === 'ContractCreator') {//重新进入当前页面，清除之前的数据
        this.contractTemplateType = ''
        this.fillForm = {
          fillOptionList: [],
          orderNumber: undefined
        }
        this.signOptionList = []
        this.templateId = undefined
        this.templateName = undefined
        this.templateText = undefined
        this.templateDetail = {}
        this.editOptionItem = {}
        this.pdfUrl = ''
        this.getTemplateList()
      }
    }
  },
  methods: {
    updateOrderShow() {
      if (this.contractTemplateType == 1) {
        return true
      } else {
        if (this.fillForm.fillOptionList && this.fillForm.fillOptionList.length > 0) {
          if (this.fillForm.fillOptionList.findIndex(item => (item.fillType === 2 || item.fillType === 3)) >= 0) {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      }
    },
    getTemplateList() {
      this.loading = true
      let url = 'pact/getPactTemplateList?pageNum=1&pageSize=10000'
      let params = {
        pactMerchantId: this.$store.getters.userInfo.merchantId,
        pactPlatformId: this.getPlatformConfig().platformId,
        pactName: '',
        signName: ''
      }
      this.getHttpServices().getServerApiService().post(url, params)
        .then(res => {
          this.getLogUtils().logWithTag('getPactTemplateList', res)
          this.templateOptions = res.pageResult.data
          this.loading = false
        }).catch(err => {
        this.getLogUtils().errorWithTag('getPactTemplateList', err)
        this.loading = false
      })
    },
    //模版变更监听
    onTemplateChange(templateId) {
      this.showSeal = false
      this.getHttpServices().getServerApiService().get('/pact/getPactTemplateInfo?pactTemplateId=' + templateId, {})
        .then(res => {
          this.pdfUrl = res.pactTemplatePdfUrl
          this.templateText = res.pactTemplateContent
          this.templateName = res.pactTemplateName
          this.templateDetail = JSON.parse(JSON.stringify(res))
          this.fillForm.fillOptionList = this.initFillOptionList(res)
          // console.error("initFillOptionList---监听",this.fillForm.fillOptionList)
          //签署项
          this.signOptionList = this.getSignatoryList(res.signatoryList)
          // let miniPdfHeight = 988;
          // this.signOptionList.forEach(item=>{
          //   const maxY = Math.max(item.signYCoordinate,item.dateYCoordinate);
          //   miniPdfHeight =Math.max(miniPdfHeight,maxY)
          // })
          // this.miniPdfHeight=miniPdfHeight;
          this.contractTemplateType = res.uploadSupervise
          this.getSuperviseLocation(res.superviseLocation)
          this.$nextTick(() => {
            this.initFinish = true
          })
          this.getLogUtils().logWithTag('getPactTemplateInfo', res)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    //初始化填充选项（右边的数据）
    initFillOptionList(detail) {
      if (detail.fillContentInfo && detail.fillContentInfo.length > 0) {
        //过滤非必填项
        return detail.fillContentInfo.filter(item => item.fillType !== 1).map(item => {
          return {
            ...item,
            name: item.fillName,
            fillCode: item.fillCode,
            isRequired: item.checkType === 3 || item.checkType === 1,
            value: undefined,
            isSpecial: ContractTemplateHelper.isSpecial(item.fillEnumKeyMean)
          }
        })
      }
      return []
    },
    /**
     *
     * @param orderNo
     * @param type订单类型 2是平台 1是云仓
     */
    getOrderDetails(orderNo, type) {
      let path = type == 2 ? '/contract/getOrderContractInfo/' + orderNo + '/' + this.contractTemplateType : '/contract/getOrderContractInfo'
      let params = {}
      if (type === 1) {
        //云仓数据
        params = {
          orderId: orderNo,
          platformId: this.getPlatformConfig().platformId,
          merchantId: this.$store.getters.userInfo.merchantId,
          uploadSupervise: this.contractTemplateType
        }
      }
      const service = type === 2 ? this.getHttpServices().getOrderService() : this.getHttpServices().getCloudOrderService()
      service.post(path, params)
        .then(detail => {
          const list = this.initFillOptionList(this.templateDetail)
          // console.error("initFillOptionList---订单",list)
          detail.routeDayPlan = ContractTemplateHelper.getRouteDayPlanTableText(detail.routeDayPlan)
          detail.orderContacts = detail.orderContacts + ',' + detail.orderPhone
          list.forEach(item => {
            if (item.fillType && item.fillEnumKeyMean) {
              item.value = ContractTemplateHelper.getContent(detail, item.fillEnumKeyMean)
            }
          })
          this.fillForm.fillOptionList = [...list]
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    validatorFillContent(rule, value, callback) {
      const index = rule.field.substring(rule.field.indexOf('.') + 1, rule.field.lastIndexOf('.'))
      if (this.fillForm.fillOptionList[index] && this.fillForm.fillOptionList[index].isRequired) {
        if (!value || (typeof value === 'string' && value.trim().length < 1) || (value instanceof Array && value.length < 1)) {
          callback(new Error('请输入' + this.fillForm.fillOptionList[index].name))
        } else {
          callback()
        }
      } else {
        callback()
      }
    },
    //应用事件
    applyEvent() {
      this.applyLoading = true
      this.showSeal = false
      this.validateOptions()
        .then(validate => {
          this.getLogUtils().errorWithTag('validateOptions', validate)
          return this.createPdf()
        }).then(res => {
        this.templateText = res.text
        this.contractPafUrl = res.url
        this.pdfUrl = res.url
        this.$message.success('数据应用成功，请重新检测盖章位置')
      }).catch(reason => {
        this.showSeal = true
        this.getLogUtils().errorWithTag('validateOptions', reason)
        if (typeof reason === 'boolean') {
          this.$message.error('请完善签署方信息')
        } else {
          this.showNetWorkErrorMessage(reason)
        }

      }).finally(() => this.applyLoading = false)
    },
    createPdf() {
      const pactContent = this.getApplySignOptions()
      return new Promise((resolve, reject) => {
        this.getHttpServices().getServerApiService().post('/pact/createPdf', { pactContent: pactContent })
          .then(url => {
            resolve({ text: pactContent, url: url })
            this.getLogUtils().logWithTag('createPdf', url)
          })
          .catch(reason => reject(reason))
      })
    },
    //应用签署信息
    getApplySignOptions() {
      const contractOptionsList = this.getContractOptionsList()
      let templateContent = this.templateDetail.pactTemplateContent
      let fillContentInfo = this.templateDetail.fillContentInfo
      //填充合同填充选项
      if (fillContentInfo && fillContentInfo.length > 0) {
        fillContentInfo.filter(item => item.fillType === 1).forEach(item => {
          let key = item.fillEnumKeyMean
          const findItem = contractOptionsList.find(oItem => oItem[key])
          if (findItem) {
            templateContent = templateContent.replaceAll(`{{${item.fillName}}}`, findItem[key])
          }
        })
      }
      if (this.fillForm.fillOptionList && this.fillForm.fillOptionList.length > 0) {
        this.fillForm.fillOptionList.forEach(item => {
          if (item.isSpecial && item.fillEnumKeyMean === '出游人') {
            let travelerTabText = ContractTemplateHelper.getTravelerTabText(item.value)
            templateContent = templateContent.replaceAll(`{{${item.fillName}}}`, travelerTabText)
          } else {
            templateContent = templateContent.replaceAll(`{{${item.fillName}}}`, item.value ? item.value : '___')
          }
        })
      }
      //填充订单相关信息
      //填充非订单、合同信息（独立信息）
      return templateContent
    },
    //获取合同签署信息
    getContractOptionsList() {
      return this.signOptionList.map((item, index) => {
        let signNum = index + 1
        return {
          [`签署方${signNum}_姓名`]: item.name,
          [`签署方${signNum}_全称`]: item.name,
          [`签署方${signNum}_证件类型`]: item.cardType,
          [`签署方${signNum}_证件号码`]: item.code,
          [`签署方${signNum}_统一社会信用代码`]: item.code,
          [`签署方${signNum}_手机号`]: item.phoneNumber
        }
      })
    },
    beforeSaveItem(record, index) {
      if (!record.tourName) {
        this.$message.error(`请输入出游人姓名`)
        return false
      }
      if (!record.cardType) {
        this.$message.error(`请选择出游人证件类型`)
        return false
      }
      if (!record.cardNo) {
        this.$message.error(`请输入出游人证件号`)
        return false
      }
      if (!record.tourPhone) {
        this.$message.error(`请输入出游人手机号`)
        return false
      }
      return true
    },
    onSaveEvent() {
      this.validateOptions()
        .then(validate => {
          if (this.contractPafUrl) {
            this.generateContract()
          } else {
            this.$message.error('请先应用填写数据')
          }
          this.getLogUtils().logWithTag('validateOptions', validate)
        }).catch(reason => {
        this.getLogUtils().errorWithTag('validateOptions', reason)
      })
    },
    validateOptions() {
      const leftPromise = this.$refs.leftComponent.validate()
      const rightPromise = new Promise((resolve, reject) => {
        this.$refs['fillForm'].validate(valid => {
          if (valid) {
            resolve(valid)
          } else {
            reject(valid)
          }
        })
      })
      return new Promise((resolve, reject) => {
        Promise.all([leftPromise, rightPromise])
          .then(list => {
            if (list[0] && list[1]) {
              resolve(true)
            } else {
              reject(list)
            }
          }).catch(reason => reject(reason))
      })

    },
    getContractParams() {
      const offsetHeight = this.$refs.customPdfViewer.offsetHeight
      const offsetWidth = this.$refs.customPdfViewer.offsetWidth
      const params = {
        pactOssPdfUrl: this.contractPafUrl,
        pactContent: this.templateText,
        pactName: this.templateName,
        height: offsetHeight,
        width: offsetWidth,
        pactTemplateId: this.templateId,
        uploadSupervise: this.contractTemplateType,
        superviseLocation: this.superviseLocation,
        fillSuperviseParam: [...this.getContractRelevanceInfo(), ...this.getFillSuperviseParam()],
        tourist: this.getFillTourist(),
        orderInfo: {
          orderNo: this.fillForm.orderNumber,
          source: this.orderType,
          token: this.$store.getters.token
        },
        merchantAndPlatform: {
          merchantId: this.$store.getters.userInfo.merchantId,
          platformId: this.getPlatformConfig().platformId
        }
      }
      if (this.signOptionList.length > 0) {
        params.signatoryList = this.signOptionList.map((item, index) => {
          const signXCoordinate = item.signXCoordinate
          const diffSignY = item.signYCoordinate
          const signYCoordinate = diffSignY > 0 ? diffSignY : 0
          const dateXCoordinate = item.dateXCoordinate
          const diffDateY = item.dateYCoordinate
          const dateYCoordinate = diffDateY > 0 ? diffDateY : 0
          const newItem = {
            automatic: item.automatic,
            signSort: index + 1,
            signType: item.signType,
            signName: item.name,
            sendMobile: item.phoneNumber,
            signXCoordinate: signXCoordinate > 0 ? signXCoordinate : 0,
            signYCoordinate: signYCoordinate > 0 ? signYCoordinate : 0,
            dateXCoordinate: dateXCoordinate > 0 ? dateXCoordinate : 0,
            dateYCoordinate: dateYCoordinate > 0 ? dateYCoordinate : 0
          }
          if (item.signType === 1 || item.signType === '1') {//企业
            newItem.socialCreditCode = item.code
          } else {
            newItem.cardNumber = item.code
            newItem.cardType = item.cardType
          }
          return newItem
        })
      }
      return params
    },
    getFillSuperviseParam() {
      if (this.contractTemplateType == 1) {
        let list = this.fillForm.fillOptionList.map(item => {
          return {
            linkCategory: 4,
            linkCode: item.sortIndex,
            linkCodeName: item.fillName,
            linkValue: item.fillName && item.fillName == '出游人' ? '' : item.value
          }
        })
        return list
      } else {
        return []
      }
    },
    getContractRelevanceInfo() {
      let fillContentInfo = this.templateDetail.fillContentInfo
      const contractOptionsList = this.getContractOptionsList()
      if (fillContentInfo && fillContentInfo.length > 0) {
        let contractList = fillContentInfo.filter(item => item.fillType === 1).map(item => {
          let key = item.fillEnumKeyMean
          const findItem = contractOptionsList.find(oItem => oItem[key])
          if (findItem) {
            return {
              linkCategory: 4,
              linkCode: item.sortIndex,
              linkCodeName: item.fillName,
              linkValue: findItem[key]
            }
          }
        })
        return contractList
      } else {
        return []
      }
    },
    getFillTourist() {
      if (this.contractTemplateType == 1) {
        const findItem = this.fillForm.fillOptionList.find(item => item.fillName == '出游人')
        if (findItem && findItem.value && findItem.value.length > 0) {
          let list = findItem.value.map(groupItem => {
            return {
              cardNumber: groupItem.cardNo,
              cardType: groupItem.cardType,
              gender: ContractTemplateHelper.checkCardContent(groupItem.cardType, groupItem.cardNo),
              name: groupItem.tourName,
              phone: groupItem.tourPhone
            }
          })
          return list
        } else {
          return []
        }
      } else {
        return []
      }
    },
    generateContract: function() {
      if (this.contractTemplateType == 1) {
        if (!this.fillForm.orderNumber) {
          this.$message.error('请填充订单号信息')
          return
        }
      }
      this.saveLoading = true
      let contractParams = this.getContractParams()
      this.getHttpServices().getServerApiService().post('/pact/editPactInfo', contractParams)
        .then(res => {
          this.$message.success('合同生成成功')
          this.getLogUtils().logWithTag('editPactInfo', res)
          setTimeout(() => this.backEvent(), 1000)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
        .finally(() => this.saveLoading = false)
    },
    //填充订单信息事件
    fillOrderInfoEvent() {
      if (!this.fillForm.orderNumber || this.fillForm.orderNumber.trim().length < 1) {
        this.$message.error('请输入订单号')
        return
      }
      this.getOrderDetails(this.fillForm.orderNumber, this.orderType)
    },
    //填充项编辑事件（出游人信息、行程信息）
    editOptionItemEvent(item, index) {
      if (item.fillEnumKeyMean === '出游人') {
        this.editColumns = this.getContactsColumns()
        this.virtualNames = ['cardType']
        this.editColumnsKeys = this.editColumns.filter(item => item.dataIndex).map(item => item.dataIndex)
      }
      this.editOptionItem = item
      // console.error("this.editOptionItem",this.editOptionItem)
    },
    //pdf渲染结结束事件
    updateSettlementEvent(e) {
      this.miniPdfHeight = e.pageNum ? 988 * e.pageNum : 988
      // console.error("======e.pageNum=====",e.pageNum)
      // console.error("====== this.miniPdfHeight=====", this.miniPdfHeight)
      this.showSeal = true
      this.getLogUtils().logWithTag('updateSettlementEvent', e)
    },
    cancelEvent() {
      this.backEvent()
    },
    onConfirmEditOptionEvent() {
      const findIndex = this.fillForm.fillOptionList.findIndex(item => item.fillEnumKeyMean === this.editOptionItem.fillEnumKeyMean)
      if (findIndex >= 0) {
        const list = [...this.fillForm.fillOptionList]
        if (this.editOptionItem.fillEnumKeyMean === '出游人') {
          this.editOptionItem.value = this.$refs.tableEditor.getTableData()
        }
        list[findIndex] = this.editOptionItem
        this.fillForm.fillOptionList = list
      }
      this.editOptionItem = {}
    },
    onCardNoChange(record, value) {
      const findItem = this.cardOrderOptions.find(item => item.key === value)
      if (findItem) {
        record.cardType = value
        record.cardTypeStr = findItem.value
      }
      // console.error("onCardNoChange",findItem)
    },
    //联系人表头
    getContactsColumns() {
      return [
        {
          title: '姓名',
          dataIndex: 'tourName',
          key: 'tourName',
          scopedSlots: { customRender: 'tourName' }
        },
        {
          title: '证件类型',
          dataIndex: 'cardType',
          key: 'cardType',
          width: 200,
          scopedSlots: { customRender: 'cardType' }
        },
        {
          title: '证件号',
          dataIndex: 'cardNo',
          key: 'cardNo',
          scopedSlots: { customRender: 'cardNo' }
        },
        {
          title: '手机号',
          dataIndex: 'tourPhone',
          key: 'tourPhone',
          scopedSlots: { customRender: 'tourPhone' }
        },
        {
          title: '操作',
          key: 'action',
          scopedSlots: { customRender: 'operation' },
          fixed: 'right'
        }
      ]
    },
    //重置签章位置
    onResetDragItemEvent() {
      if (this.templateDetail.signatoryList && this.templateDetail.signatoryList.length > 0) {
        const list = [...this.signOptionList]
        list.forEach((item, index) => {
          const findItem = this.templateDetail.signatoryList[index]
          if (findItem) {
            item.signXCoordinate = findItem.signXCoordinate ? Number.parseInt(findItem.signXCoordinate) : 0
            item.signYCoordinate = findItem.signYCoordinate ? Number.parseInt(findItem.signYCoordinate) : 0
            item.dateXCoordinate = findItem.dateXCoordinate ? Number.parseInt(findItem.dateXCoordinate) : 0
            item.dateYCoordinate = findItem.dateYCoordinate ? Number.parseInt(findItem.dateYCoordinate) : 0
          }
          this.signOptionList = list
        })
      }
      if (this.contractTemplateType == 1) {
        let oldData = this.templateDetail.superviseLocation
        if (oldData) {
          this.superviseLocation.codeXCoordinate = oldData.codeXCoordinate ? Number.parseInt(oldData.codeXCoordinate) : 0
          this.superviseLocation.codeYCoordinate = oldData.codeYCoordinate ? Number.parseInt(oldData.codeYCoordinate) : 0
          this.superviseLocation.qrCodeXCoordinate = oldData.qrCodeXCoordinate ? Number.parseInt(oldData.qrCodeXCoordinate) : 0
          this.superviseLocation.qrCodeYCoordinate = oldData.qrCodeYCoordinate ? Number.parseInt(oldData.qrCodeYCoordinate) : 0
        }
      }
    }
  }

}
</script>
<style scoped lang="less">
.box-bg {
  width: 100%;
  background-color: white;
  height: 100%;
}

.left-content-box {
  width: 100%;
  height: 750px;
  min-height: 750px;
  max-height: 750px;
  overflow-y: scroll;
  background-color: white;
  box-sizing: border-box;
  padding-bottom: 20px;
}

.center-box {
  .box-bg;
  height: 750px;
  max-height: 750px;
  overflow-y: scroll;
  text-align: center;
}

.title-box {
  height: 55px;
  line-height: 55px;
  padding-left: 16px;
  background-color: white;
  border-bottom: 1px solid #e9e9e9;
  position: relative;

  span {
    font-size: 16px;
  }
}

.right-content-box {
  .box-bg;
  height: 750px;
  max-height: 750px;
  overflow-y: scroll;

  .line-box {
    padding-top: 10px;
    padding-bottom: 4px;
    padding-left: 16px;
    padding-right: 16px;
    width: 100%;
    box-sizing: border-box;
  }

  .left-title {
    font-weight: 400;
    font-size: 14px;
    color: #333333;
  }
}

.drag-box-1 {
  position: relative;
  height: 66px;
  width: 160px;

  img {
    width: 100%;
    height: 100%;
  }

  span {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    line-height: 66px;
    text-align: center;
    font-size: 16px;
    color: #FAAD14;
  }
}

.drag-box {
  position: relative;
  height: 160px;
  width: 160px;

  img {
    width: 100%;
    height: 100%;
  }

  span {
    position: absolute;
    bottom: 16px;
    left: 0;
    right: 0;
    text-align: center;
    font-size: 16px;
    color: #FAAD14;
  }
}

.drag-box-2 {
  position: relative;
  height: 36px;
  width: 206px;

  img {
    width: 100%;
    height: 100%;
  }

  span {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    line-height: 36px;
    text-align: center;
    font-size: 16px;
    color: #FAAD14;
  }
}

.custom-tab {
  .ant-table-thead > tr > th, .ant-table-tbody > tr > td {
    padding-left: 4px;
    padding-right: 4px;
    padding-top: 16px;
    padding-bottom: 16px;
  }
}

.drag-float-box {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 999;
}

.box-height {
  width: 100%;
  height: 750px;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 901;
  background-color: transparent;
}

.contract_code_image {
  width: 240px;
  height: 32px;

  img {
    width: 100%;
    height: 100%;
    display: block;
  }
}

.qrcode_image {
  width: 160px;
  height: 160px;

  img {
    width: 100%;
    height: 100%;
    display: block;
  }
}

img {
  cursor: pointer;
}
</style>